import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  viewCourseIn: {
    id: 'instructorToolbar.viewCourseIn',
    defaultMessage: 'View course in:',
    description: 'Text for the view course in button',
  },
});

export default messages;
